var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandSingle24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M10.6 17c.28-1.6.71-3.1.71-3.1.16-.53.65-.9 1.2-.9.8 0 1.4.73 1.24 1.52L13.06 17m-2.47 0c-.2 1.17-.98 1.5-.98 1.5m.98-1.5H9c-.8 0-.93-.67-.9-1v-3.5m4.96 4.5c-.2 1 .76.8.99 2.24.12.76-.4 2.26-1.7 2.26H9.07c-2.46 0-2.17-.55-3.77-4.76-.34-.9-1-1.84 1.96-3.74l.84-.5m4.95 4.5h3.95c.99 0 .99 0 .99-1V3.95C18 3 18 3 17.02 3h-7.9c-.74 0-1 .05-1 1l-.01 8.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandSingle24);
export default __webpack_public_path__ + "static/media/hand_single_24.41327ee856c4bd9c00b2a370326beb1a.svg";
export { ForwardRef as ReactComponent };